export default __webpack_public_path__ + "static/media/Allied Health Sciences.4f131f2d.png";